import { Mui } from "@osu/react-ui";
import { Fragment } from "react";

const labelReset = "Restore Defaults";

function ResetDefaults({ onSubmit, open, setOpen }) {

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Mui.Button onClick={handleClickOpen} size="small" color="error">
        {labelReset}
      </Mui.Button>
      <Mui.Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            onSubmit()
          },
        }}
      >
        <Mui.DialogTitle component="h2">{labelReset}</Mui.DialogTitle>
        <Mui.DialogContent>
          <Mui.DialogContentText>
            This action allows you to restore your Quick Links section to our
            default list of suggested links. Any customs preferences will be permanently
            lost.
          </Mui.DialogContentText>
        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Button onClick={handleClose}>Cancel</Mui.Button>
          <Mui.Button className="margin-left-auto" color="error" type="submit">
            {labelReset}
          </Mui.Button>
        </Mui.DialogActions>
      </Mui.Dialog>
    </Fragment>
  );
}
export default ResetDefaults;
